module.exports = __webpack_public_path__ + "static/media/guestlist-white-bg-trimmed.673175b2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/guestlist-white-bg-trimmed.svg
// module id = 1793
// module chunks = 51